export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';
export const DIALOG_LOADED = 'DIALOG_LOADED';
export const RESET_DIALOG_STATE = 'RESET_DIALOG_STATE';
export const ADD_DIALOG = 'ADD_DIALOG';
export const REMOVE_DIALOG = 'REMOVE_DIALOG';